export enum LogoutMessages {
  EXPIRED = 'auth.logout.expired',
  ISSUE = 'auth.logout.issue',
  VERIFICATION = 'auth.logout.verification',
  SUCCESS = 'auth.logout.success',
}
